<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <app-upsert
          :config="config"
          :item="drug"
          title='Balance'
          hide-save
          class="mb-3">
        </app-upsert>
        <v-card v-if='detail.protocol_name'>
          <div class="float-right pull-right mr-2"><v-switch inset v-model="showConfirmed" hint="Show order we do not have batch n. details yet" persistent-hint label="Show Confirmed/Sent too"/></div>
          <v-card-title>
            {{detail.protocol_name}} - {{detail.site_name || detail.place_name || detail.storage_name}}<br/>
            {{detail.drug_name}} - <template v-if="detail.lotto">{{detail.lotto}}</template><template v-else>Labels</template><br/>
            Quantity: {{detail.n}}<template v-if="detail.expiration"> - Expiration: {{detail.expiration}}</template>
          </v-card-title>
          <v-card-subtitle v-if='detail.serials'>
              {{detail.serials}}
          </v-card-subtitle>
        </v-card>
        <v-timeline align-top dense v-if='detail.protocol_name' :set='total = 0'>
          <v-timeline-item
            v-for="(dd, i) in timeline.filter(t => showConfirmed || t.type != 'CONFIRMED')"
            :key="i"
            small
            style="max-width: 99%; padding-bottom: 4px"
            :set="total = calTotal(dd, total)"
          >
            <v-card dark :color='color(dd)' :to='url(dd)' small>
              <v-card-title class="headline pa-1 pt-0 pl-3 pb-3" style="display: block">
                <b style="font-size: 0.65em; line-height: 20px"
                  >{{ dd['response_date'] || dd['request_date'] }} - {{ dd['type'] }} <small>({{dd['status']}})</small></b>
              </v-card-title>
              <v-card-subtitle class="pb-2">
                {{ dd['place_name'] || detail.storage_name}}<br/>
                <v-chip color='error' small light><strong>{{ dd['n_pieces'] }}</strong></v-chip> {{ dd['serials'] }} {{ dd['serials_partially'] ? ' / ' + dd['serials_partially'] : '' }} (total: {{total}})
              </v-card-subtitle>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import config from './config_balance.js'
import { balanceDetails } from '@/api/balance'
import helpers from '../../helpers'

export default {
  data ({ $route }) {
    return {
      config,
      drug: {
        protocol_id: Number($route.query.protocol_id),
        drug_id: Number($route.query.drug_id),
        lotto: $route.query.lotto,
        site_id: Number($route.query.site_id),
        packaging: $route.query.packaging
      },
      showConfirmed: false,
      detail: {},
      timeline: [],
    }
  },
  created () {

    if (this.drug.drug_id && (this.drug.lotto || this.drug.packaging === 'Labels')) {
      this.search()
    }

  },
  watch: {
    drug: {
      handler: function (drug) {
        this.$router.push({ query: {
          protocol_id: drug.protocol_id || '',
          drug_id: drug.drug_id || '',
          site_id: drug.site_id || '', 
          lotto: drug.lotto,
          packaging: drug.packaging
        }}).catch()
        if (drug.drug_id && (drug.lotto || drug.packaging === 'Labels')) {
          this.search()
        } else {
          this.timeline = []
          this.detail = {}
        }
      }, 
      deep: true
    }
  },
  methods: {
    async search () {
      const ret = await balanceDetails(this.drug.drug_id, this.drug.lotto || '_labels', this.drug.site_id)
      this.detail = ret.detail
      this.timeline = ret.timeline
    },
    color (item) {
      const map = {
        REQUEST: 'primary',
        TRANSFER: 'warning',
        SITEREQUEST: 'secondary',
        RETURNED: 'danger',
        DISPOSED: 'alert',
        FULLYUSED: 'green',
        PATCH: 'indigo',
        CONFIRMED: 'warning'
      }
      return map[item.type]

    },
    calSerials (item, serials) {
      if (item.type === 'REQUEST') {
        return helpers.compatSerials(helpers.mergeSerials(serials, item.serials))
      } else {
        return helpers.compatSerials(helpers.subtractSerials(serials, item.serials))
      }
    },
    calTotal (item, total) {
      let map = {}
      if (this.detail.site_code) {
        map = {
          TRANSFER: -1,
          SITEREQUEST: 1,
          RETURNED: -1,
          DISPOSED: -1,
          FULLYUSED: -1,
          PATCH: 1
        }
      } else {
        map = {
          PATCH: 1,
          REQUEST: 1,
          TRANSFER: 1,
          SITEREQUEST: -1,
          DISPOSED: -1,
          CONFIRMED: -1,
        }
      }

      return total + (item.n_pieces * map[item.type])
    },
    url (item) {
      const map = {
        REQUEST: 'request',
        TRANSFER: 'siterequest',
        SITEREQUEST: 'siterequest',
        CONFIRMED: 'siterequest',
        RETURNED: 'returned',
        DISPOSED: 'disposed',
        FULLYUSED: 'fullyused',
        PATCH: 'patch'
      }

      return `${map[item.type]}/${item.id}`
    }
  }
}
</script>

